import { render, staticRenderFns } from "./PhotoUploadManualSection.vue?vue&type=template&id=2bac293e&"
import script from "./PhotoUploadManualSection.vue?vue&type=script&lang=js&"
export * from "./PhotoUploadManualSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports